import { render } from "./SourceConfiguration.vue?vue&type=template&id=33dfb596"
import script from "./SourceConfiguration.vue?vue&type=script&lang=js"
export * from "./SourceConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__